/**
 * − / + steps for the Login Limit number fields (Limit, Hours budget and the
 * license type limits). Values are whole numbers of 1 or more; an empty field
 * stays empty until the admin types or steps, so an optional field can stay unset.
 */

export const STEP_MIN = 1;
const STEP_MAX = Number.MAX_SAFE_INTEGER;

function wholeNumber(text: string): number | null {
  const trimmed = text.trim();
  return /^\d+$/.test(trimmed) ? Number(trimmed) : null;
}

export function canStepUp(text: string): boolean {
  const current = wholeNumber(text);
  return current === null || current < STEP_MAX;
}

export function canStepDown(text: string): boolean {
  const current = wholeNumber(text);
  return current !== null && current > STEP_MIN;
}

/** Empty or 0 steps up to 1; nothing steps below 1. */
export function stepLimitText(text: string, delta: 1 | -1): string {
  const current = wholeNumber(text);
  if (delta > 0) {
    if (current === null || current < STEP_MIN) return String(STEP_MIN);
    return String(Math.min(current + 1, STEP_MAX));
  }
  if (current === null || current <= STEP_MIN) return text;
  return String(Math.min(current - 1, STEP_MAX));
}

/** The value for `aria-valuenow`, or undefined while the field is empty or not a whole number. */
export function stepperValueNow(text: string): number | undefined {
  return wholeNumber(text) ?? undefined;
}
